import { render, staticRenderFns } from "./NewPlatformBadge.vue?vue&type=template&id=8cee337e&scoped=true&"
import script from "./NewPlatformBadge.vue?vue&type=script&lang=js&"
export * from "./NewPlatformBadge.vue?vue&type=script&lang=js&"
import style0 from "./NewPlatformBadge.vue?vue&type=style&index=0&id=8cee337e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cee337e",
  null
  
)

/* custom blocks */
import block0 from "./NewPlatformBadge.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports